import { QueryClient, useMutation, useQueryClient } from '@tanstack/react-query'
import { taskKeys, RequestTypes } from '@core/react-query/features/tasks/task'
import { tasksKeys } from '@core/react-query/features/tasks/tasks'
import { useMutateQueryData } from '@core/react-query/hooks'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { ITask } from '@core/entities/task/Task'

export const getUpdateTaskDraftMutationOptions = (
  queryClient?: QueryClient,
) => {
  const { updateInfiniteQueryItem } = useMutateQueryData(queryClient)
  return {
    ...taskKeys.updateTaskDraft,
    onSuccess: (task, variables) => {
      updateInfiniteQueryItem(
        tasksKeys.draftTasks({
          organisationId: variables.organisationId,
          projectIds: [variables.projectId],
        }).queryKey,
        task,
      )
    },
  }
}

export const useUpdateTaskDraft = () => {
  const queryClient = useQueryClient()
  return useMutation<ITask, RequestErrorType, RequestTypes['updateTaskDraft']>(
    getUpdateTaskDraftMutationOptions(queryClient),
  )
}
